import { render, staticRenderFns } from "./SalaryScheduleTable.vue?vue&type=template&id=2bd83c46&scoped=true&"
import script from "./SalaryScheduleTable.vue?vue&type=script&lang=js&"
export * from "./SalaryScheduleTable.vue?vue&type=script&lang=js&"
import style0 from "./SalaryScheduleTable.vue?vue&type=style&index=0&id=2bd83c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd83c46",
  null
  
)

export default component.exports